"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listApiAuditLog = exports.revokeApiKey = exports.createApiKey = exports.listApiKeys = void 0;
const fetchInstance_1 = require("../../../utils/fetchInstance");
/**
* @summary Pro feature E — list this shop's public API keys (Pro only)
*/
const listApiKeys = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/api-keys`, method: 'get'
    });
};
exports.listApiKeys = listApiKeys;
/**
* @summary Create a new public API key — the plaintext token is returned once, in this response only
*/
const createApiKey = (createApiKeyDto) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/api-keys`, method: 'post',
        headers: { 'Content-Type': 'application/json', },
        data: createApiKeyDto
    });
};
exports.createApiKey = createApiKey;
/**
* @summary Revoke a public API key
*/
const revokeApiKey = (id) => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/api-keys/${id}`, method: 'delete'
    });
};
exports.revokeApiKey = revokeApiKey;
/**
* @summary Every write made through the public API, with the key that made it
*/
const listApiAuditLog = () => {
    return (0, fetchInstance_1.fetchInstance)({ url: `/api/api-keys/audit-log`, method: 'get'
    });
};
exports.listApiAuditLog = listApiAuditLog;
